module.exports = __webpack_public_path__ + "img/photo3_6.73221795.jpg";